import { useLanguage } from "@/lib/i18n";
import { LegalPageLayout } from "./LegalPageLayout";

export default function ReturnPolicyPage() {
  const { t } = useLanguage();

  return (
    <LegalPageLayout titleKey="legal.returns.title" seoDescriptionKey="legal.returns.seoDescription" pagePath="/returns">
      <h1 className="text-2xl md:text-3xl font-bold mb-2">{t('legal.returns.title')}</h1>
      <p className="text-sm text-muted-foreground mb-4">{t('legal.returns.effectiveDate')}</p>
      <p className="text-sm text-muted-foreground mb-8 italic">{t('legal.returns.intro')}</p>

      <Section title={t('legal.returns.s1.title')}>
        <P>{t('legal.returns.s1.1')}</P>
        <P>{t('legal.returns.s1.2')}</P>
      </Section>

      <Section title={t('legal.returns.s2.title')}>
        <P>{t('legal.returns.s2.1')}</P>
        <P>{t('legal.returns.s2.2')}</P>
        <P>{t('legal.returns.s2.3')}</P>
      </Section>

      <Section title={t('legal.returns.s3.title')}>
        <P>{t('legal.returns.s3.1')}</P>
        <P>{t('legal.returns.s3.2')}</P>
        <P>{t('legal.returns.s3.3')}</P>
      </Section>

      <Section title={t('legal.returns.s4.title')}>
        <P>{t('legal.returns.s4.1')}</P>
      </Section>

      <Section title={t('legal.returns.s5.title')}>
        <P>{t('legal.returns.s5.1')}</P>
      </Section>
    </LegalPageLayout>
  );
}

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <section className="mb-8">
      <h2 className="legal-heading text-lg font-semibold mb-3">{title}</h2>
      {children}
    </section>
  );
}

function P({ children }: { children: React.ReactNode }) {
  return <p className="legal-content text-sm text-muted-foreground leading-relaxed mb-2">{children}</p>;
}
